import React from 'react';
import PartnerInfo from '../../components/partnermng/PartnerInfo';

const PartnerInfoContainer = ({partner}) => {
  return <PartnerInfo partner={partner}/>;
};

export default PartnerInfoContainer;
